/* eslint-disable import/no-webpack-loader-syntax */
import { images as airborneImages } from "./cutouts/airborne.yml"
import { images as groundedImages } from "./cutouts/grounded.yml"
import { images as regularImages } from "./cutouts/regular.yml"

const images = []

airborneImages.forEach((img) => {
	images.push({ ...img, airborne: true })
})
groundedImages.forEach((img) => {
	images.push({ ...img, grounded: true })
})
regularImages.forEach((img) => {
	images.push({ ...img, regular: true })
})

export default images
